import { useConsent } from '../../hooks/useConsent'
import ConsentPopup from './ConsentPopup'

interface Props {
  children: React.ReactNode
}

/**
 * Renders the consent popup over the app shell when the signed-in admin
 * hasn't accepted the current ToS + Privacy versions.
 */
export default function ConsentGate({ children }: Props) {
  const { needsUserConsent, acceptUserConsent } = useConsent()

  return (
    <>
      {children}
      {needsUserConsent && <ConsentPopup onAccept={acceptUserConsent} />}
    </>
  )
}
